import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

import ApiTour from "../../../API/ApiTour";
import styles from "./boutiqueStyles";
import BoutiqueView from "./boutiqueView";

const ON_REQUEST_OVERRIDES = {
  594: {
    type: "on_request",
    nbEnigmas: 151,
    nbZones: 1,
    moreInfoUrl: "https://landingzone.app/world-flags-activite-team-building-grand-groupe/",
  },
};

const applyOverrides = (themes) =>
  (themes || []).map((theme) => ({
    ...theme,
    tours: (theme.tours || []).map((tour) =>
      ON_REQUEST_OVERRIDES[tour.id]
        ? { ...tour, ...ON_REQUEST_OVERRIDES[tour.id] }
        : tour
    ),
  }));

class BoutiqueComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateData: [],
      isLoading: false,
      errorMessage: "",
      selectedThemeIndex: 0,
      copyingTourId: null,
      descriptionAnchorEl: null,
      selectedTourForDescription: null,
      requestDialogTour: null,
      isRequesting: false,
      requestSuccess: false,
    };
  }

  componentDidMount() {
    document.title = "Boutique | Landing Zone";
    this.fetchTemplates();
  }

  fetchTemplates = async () => {
    this.setState({ isLoading: true, errorMessage: "" });
    const response = await ApiTour.getTemplateTours();
    if (response.status === 200) {
      this.setState({
        templateData: applyOverrides(response.data.themes),
        selectedThemeIndex: 0,
      });
    } else {
      this.setState({ errorMessage: this.props.t("boutique.error_loading") });
    }
    this.setState({ isLoading: false });
  };

  handleCopyTour = async (tourId) => {
    this.setState({ copyingTourId: tourId, errorMessage: "" });
    const response = await ApiTour.copyTemplateTour(tourId);
    if (response.status === 201) {
      this.props.history.push("/", {
        successMessage: this.props.t("boutique.success_copy"),
      });
    } else if (response.status === 403) {
      this.setState({
        errorMessage: this.props.t("boutique.error_limit_reached"),
        copyingTourId: null,
      });
    } else {
      this.setState({
        errorMessage: this.props.t("boutique.error_copy"),
        copyingTourId: null,
      });
    }
  };

  handleOpenDescription = (event, tour) => {
    this.setState({
      descriptionAnchorEl: event.currentTarget,
      selectedTourForDescription: tour,
    });
  };

  handleCloseDescription = () => {
    this.setState({ descriptionAnchorEl: null, selectedTourForDescription: null });
  };

  handleOpenRequestDialog = (tour) => {
    this.setState({ requestDialogTour: tour, requestSuccess: false });
  };

  handleCloseRequestDialog = () => {
    this.setState({ requestDialogTour: null, isRequesting: false, requestSuccess: false });
  };

  handleResetError = () => {
    this.setState({ errorMessage: "" });
  };

  handleConfirmRequest = async () => {
    const { requestDialogTour } = this.state;
    if (!requestDialogTour) return;
    this.setState({ isRequesting: true });
    const response = await ApiTour.requestTemplateTour(requestDialogTour.id);
    this.setState({ isRequesting: false });
    if (response.status === 200 || response.status === 201) {
      this.setState({ requestSuccess: true });
    } else {
      this.setState({
        errorMessage: this.props.t("boutique.error_request"),
        requestDialogTour: null,
      });
    }
  };

  getCurrentTours = () => {
    const { templateData, selectedThemeIndex } = this.state;
    return selectedThemeIndex === 0
      ? templateData.flatMap((theme) =>
        (theme.tours || []).map((tour) => ({ ...tour, themeName: theme.name }))
      )
      : (templateData[selectedThemeIndex - 1]?.tours || []).map((tour) => ({
        ...tour,
        themeName: templateData[selectedThemeIndex - 1]?.name,
      }));
  };

  render() {
    const { classes, t } = this.props;
    const {
      templateData,
      isLoading,
      errorMessage,
      selectedThemeIndex,
      copyingTourId,
      descriptionAnchorEl,
      selectedTourForDescription,
      requestDialogTour,
      isRequesting,
      requestSuccess,
    } = this.state;

    const currentTours = this.getCurrentTours();
    const featuredTours = currentTours.filter((t) => t.type === "on_request");
    const regularTours = currentTours.filter((t) => t.type !== "on_request");

    return (
      <BoutiqueView
        classes={classes}
        t={t}
        templateData={templateData}
        isLoading={isLoading}
        errorMessage={errorMessage}
        handleResetError={this.handleResetError}
        selectedThemeIndex={selectedThemeIndex}
        setSelectedThemeIndex={(i) => this.setState({ selectedThemeIndex: i })}
        featuredTours={featuredTours}
        regularTours={regularTours}
        copyingTourId={copyingTourId}
        handleCopyTour={this.handleCopyTour}
        descriptionAnchorEl={descriptionAnchorEl}
        selectedTourForDescription={selectedTourForDescription}
        handleOpenDescription={this.handleOpenDescription}
        handleCloseDescription={this.handleCloseDescription}
        requestDialogTour={requestDialogTour}
        isRequesting={isRequesting}
        requestSuccess={requestSuccess}
        handleOpenRequestDialog={this.handleOpenRequestDialog}
        handleCloseRequestDialog={this.handleCloseRequestDialog}
        handleConfirmRequest={this.handleConfirmRequest}
      />
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(withTranslation()(BoutiqueComponent))
);
